<script lang="ts">
import { defineComponent, reactive } from 'vue'
import PageHeadingDefault from '@/components/_core/PageHeadingDefault.vue'
import stateInitializer from '@/models/stateInitializer'

export default defineComponent({
  name: 'ThemePageHeading',

  components: {
    PageHeadingDefault,
  },

  setup() {
    interface State {
      label: string,
    }

    const state: State = reactive({
      label: '',
    })

    stateInitializer(state, 'pageHeading')

    return {
      // data
      state,
    }
  },
})
</script>

<template>
  <PageHeadingDefault>
    {{ state.label }}
  </PageHeadingDefault>
</template>
